import React, { FunctionComponent } from 'react'
import { useCheckoutState, usePreferredCard } from '../../state'
import { MessageInline, MessageKinds, DesignLanguage, useIsDesignLanguage } from '@afterpaytouch/core'
import { TrackOnMount } from '../../integrations/monitoring'
import { TrackingEvent } from '../../model/monitoring'
import { isUndefinedOrEmpty, valueIsNotNullOrUndefined } from '@afterpay/utils'
import { useCheckoutSizes } from '../../utils/responsive'

interface Props {
  message?: React.ReactNode
  testNamespace?: string
  kind?: MessageKinds
}

export const ErrorText: FunctionComponent<Props> = ({ message = '', testNamespace = '', kind = 'Error' }) => {
  const { card, reason } = usePreferredCard() ?? {}
  const { smallTextSize } = useCheckoutSizes()
  const { error } = useCheckoutState() ?? {}
  const testId = `${testNamespace.length > 0 ? `${testNamespace}-` : ''}error`
  const hasCardError = valueIsNotNullOrUndefined(card) && valueIsNotNullOrUndefined(reason)
  const shouldTrackNonTerminalError = valueIsNotNullOrUndefined(error) || hasCardError
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)

  if (!message || (typeof message === 'string' && isUndefinedOrEmpty(message))) {
    return null
  }

  const shouldUseErrorKind = !isArcadeDesignLanguage || kind === 'Error'

  return (
    <>
      <MessageInline kind={shouldUseErrorKind ? 'Error' : 'Info'} description={message} descriptionSize={smallTextSize} testNameSpace={testId} />
      {shouldTrackNonTerminalError && (
        <TrackOnMount
          eventName={TrackingEvent.VIEWED_NON_TERMINAL_ERROR}
          eventProperties={{ ...(valueIsNotNullOrUndefined(error) && { errorCode: error?.error }), ...(hasCardError && { cardError: reason }) }}
        />
      )}
    </>
  )
}
